import React from "react";
import ReactDOM from "react-dom";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { showNotification } from './notification';
import jsencrypt from 'jsencrypt'

const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOJu6TyygqxfWT7eLtGDwajtN
FOb9I5XRb6khyfD1Yt3YiCgQWMNW649887VGJiGr/L5i2osbl8C9+WJTeucF+S76
xFxdU6jE0NQ+Z+zEdhUTooNRaY5nZiu5PgDB0ED/ZKBUSLKL7eibMxZtMlUDHjm4
gwQco1KRMDSmXSMkDwIDAQAB
-----END PUBLIC KEY-----`;

let encryption = new jsencrypt();
encryption.setPublicKey(publicKey);
export default class Loginmodal extends React.Component {

    state = {
        isEmail: false,
        password:'',
        country_code: ''
    }
    constructor(props) {
        super(props);
        this.escFunction = this.escFunction.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.inputRef = React.createRef();
    }

    escFunction(event) {
        if (event.keyCode === 27) {
            this.onToggle();
        }
    }
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }
    onToggle = () => {
        let Loginmodal = document.querySelector('#loginModal');
        ReactDOM.unmountComponentAtNode(Loginmodal);
    }
    onHandleChange(e) {
        this.setState({
          password: e.target.value
        });
      }
    doLogin(ev) {
        let  { email, password } = ev.target.elements;
        let  new_email = email.value;
        let  _codes = this.state.country_code;
        if(this.state.isEmail == false){
            if(new_email){
                if (new_email.indexOf("+")<0){
                    new_email =_codes + new_email;
                }
            } 
        }
        let  encryptedPass = encryption.encrypt(password.value);
        const _json_body = JSON.stringify({ email: new_email, password: encryptedPass });

        fetch(`${BASE.url}login`, {
            method: 'POST',
            headers: {
                'ApiKey': 'd5ab8dc7ef67ca92e41d730982c5c602',
                'Content-Type': 'application/json'
            },
            body: _json_body
        }).then(res => {
            return res.json()
        }).then(res => {
            const { code, status, auth_token, user_id, message } = res;
            if (status == 1 && auth_token) {
                // AUTH_TOKEN = auth_token;
                USER_AUTH = true;
                MY_ID = user_id;

                showNotification({
                    'title': message,
                    'type': 'success',
                    'message': message
                });

                if ('next_callback' in this.props) {
                    try {
                        this.props.next_callback();
                    } catch (e) { }
                } else {
                }

                setTimeout(() => {
                    this.onToggle();
                    window.location.reload();
                }, 500);
            }
            if (status == 0) {
                showNotification({
                    'title': message,
                    'type': 'error',
                    'message': message,
                });
                this.setState({
                    password: ''
                });
            }
        });

        ev.preventDefault();
        return false;
    }

    checkInputType(valid) {

        const { current } = this.inputRef;
        const { tel } = current;
        const country_codes  = current.state.dialCode;
        const value = tel.getAttribute('value');
        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
        const isEmail = pattern.test(value);
        this.setState({
            country_code:country_codes,
            isEmail,
        })
        return valid;
    }

    componentDidMount() {
        this.inputRef.current.tel.setAttribute('type', 'text');
    }

    render() {
        const { isEmail } = this.state;
        let resetpassword = `${BASE.url}resetPassword`;
        return (
            <div className='App'>
                <div className="content">
                    <div id="infoModal" className="modal_v4">
                        <div className="modalHeader">
                            {modalV4.login_btn}
                        </div>
                        <div className="modalBody">
                            <form onSubmit={(ev) => this.doLogin(ev)}>
                                <div className="form-group">
                                    <IntlTelInput
                                        numberType="MOBILE"
                                        initialCountry="sd"
                                        defaultCountry="sd"
                                        nationalMode={true}
                                        autoHideDialCode={false}
                                        separateDialCode={true}
                                        containerClassName={`intl-tel-input ${isEmail ? 'email' : ''}`}
                                        inputClassName="form-control"
                                        className="input"
                                        fieldName="email"
                                        autoComplete="off"
                                        onPhoneNumberChange={e => this.checkInputType(e)}
                                        ref={this.inputRef}
                                        htmlAttr={{ type: 'text' }}
                                    />
                                </div>
                                <div className="form-group">
                                    <input type="password" value={this.state.password} onChange={this.onHandleChange} placeholder={modalV4.password} name="password" className="form-control" />
                                </div>
                                <div className="modalFooter">
                                    <button type="submit" className="btn primary-1-btn">{modalV4.login_btn}</button>
                                    <a className="login-fb" href={`${BASE.url}redirect`}><span> {modalV4.facebook}
                                        <img src={`${BASE.urls}/v4/image/facebook.svg`} className='imagemodal' /></span></a>
                                </div>
                                <div className="link_login">
                                    <a className="forgetpassword" href={resetpassword}>{modalV4.forgetpassword}

                                    </a>
                                </div>
                                <div className="link_login">
                                    <a className="register-link" href={`${BASE.url}register`}>{modalV4.Registration}</a>
                                </div>
                                <div className="link_login">
                                    <a className="close" onClick={this.onToggle}>{modalV4.close}</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}